import { ExoticComponent, useEffect, useState } from 'react';
import { Preloader, PreloaderContainer } from './styles';
import { WithPreloaderHOC } from '.';
import { Flex } from '../flex';
import { Typography } from '../typography';

export function withPreloader<P extends WithPreloaderHOC>(
	Component: React.ComponentType<P> | ExoticComponent,
	PreloaderSpinnerContainer = PreloaderContainer,
	PreloaderSpinner: React.ComponentType = Preloader,
) {
	return (props: Omit<P, keyof WithPreloaderHOC> & WithPreloaderHOC) => {
		const [showPreloader, setShowPreloader] = useState(false);
		const { isLoading, error, ...restProps } = props;

		useEffect(() => {
			let timer: NodeJS.Timeout;
			if (isLoading) {
				setShowPreloader(true);
			} else {
				timer = setTimeout(() => {
					setShowPreloader(false);
				}, 500);
			}

			return () => clearTimeout(timer);
		}, [isLoading]);

		return (
			<>
				{showPreloader ? (
					<PreloaderSpinnerContainer>
						<PreloaderSpinner />
					</PreloaderSpinnerContainer>
				) : (
					!error && <Component {...(restProps as P)} />
				)}

				{error && <Flex $justify="center" $height="100%" $alignItems="center"><Typography mode={'large'}>Произошла ошибка загрузки данных</Typography></Flex>}
			</>
		);
	};
}
